import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef, LOCALE_ID, Input, Renderer2, NgZone } from '@angular/core';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';

import { countries } from 'src/app/resources/countries';
import { FormModel } from 'src/app/models/form.model';

import { SelectEvent, FileRestrictions, CancelEvent} from '@progress/kendo-angular-upload';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { TipoFerramenta } from 'src/app/models/tipoferramenta.model';
import { DialogCloseResult, DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { IntlService } from '@progress/kendo-angular-intl';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { Enum } from 'src/app/models/enum.model';
import { Observable } from 'rxjs';
import { ApiConfig, RequestConfig } from 'src/app/configs';
import { HttpClient } from '@angular/common/http';
import { Keys } from '@progress/kendo-angular-common';
import { CellClickEvent, CellCloseEvent, AddEvent, SaveEvent, RemoveEvent , GridComponent } from '@progress/kendo-angular-grid';
import { AvariasTipoFerramentaViewModel } from 'src/app/models/avariatipoferramenta.model';
import { Site } from 'src/app/models/site.model';

@Component({
    selector: 'app-tools-import-form-component',
    templateUrl: './tools-import-form.component.html'
})
export class ToolImportFormComponent extends DialogContentBase  implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public editDataItem: any;
    public currentGridRef: GridComponent | undefined ;
    @Input() public isNew = false;
    public formGroup: FormGroup = new FormGroup({});
    public countries = countries;
 
    public fileRestrictions: FileRestrictions = {
        allowedExtensions: ['.csv']
    };

public texto :string[]=[];
 

    public customMsgService: CustomMessagesService;
    listItemsTamanhos: Enum[]= [];

    constructor(private dialogService: DialogService,public msgService: MessageService,private notificationService: NotificationService,public override dialog: DialogRef,private intl: IntlService,private api: ApiService   ,private formBuilder: FormBuilder,private renderer: Renderer2, public zone: NgZone,) {
        super(dialog);
        this.setFormValues();
        this.customMsgService = this.msgService as CustomMessagesService;
       
    }
    ngOnInit(): void {
    }

    public setFormValues() {
      this.formGroup = new FormGroup({ file: new FormControl(null),});
     }

    public saveChanges(): void {
 var  f = this.formGroup.controls['file'].value[0];

  

        this.api.saveMultiPart<BaseHttpResponse<string[]>>("Ferramentas/ImportaFerramenta",{}, f).then((res) => {
          if (res) {

            this.notificationService.show({
                content:this.customMsgService.translate('registoGravadoComSucesso') ,
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'bottom' },
                type: { style: 'success', icon: true },
                hideAfter: 2000
            });
          this.texto = res.value;
          } else {

          }
        });
    }

    public cancelChanges(): void {
        this.setFormValues();
    }

    public isFileAllowed(file: any): boolean {
        return <boolean>this.fileRestrictions.allowedExtensions?.includes(file.extension);
    }

    public selectAvatar(ev: SelectEvent): void {

        const  reader = new FileReader();
    }
}
